// Zendesk-only chat service
let enabled = true;
let opened = false;

const openZendeskChat = () => {
	if (window.zE) {
		window.zE('messenger', 'show');
		window.zE('messenger', 'open');
	}
};

const InAppChat = {
	enable: () => {
		enabled = true;
	},
	disable: () => {
		enabled = false;
	},
	isEnabledAndLoaded: () => {
		return enabled;
	},
	isOpened: () => {
		return opened;
	},
	open: () => {
		openZendeskChat();
	},
	close: () => {
		// Zendesk close handled via UI
		opened = false;
	},
	// eslint-disable-next-line no-unused-vars
	updateUser: props => {
		// User updates now handled via Zendesk authentication
	},
	update: () => {
		// Updates now handled via Zendesk
	},
	// eslint-disable-next-line no-unused-vars
	init: props => {
		// Initialization now handled via Zendesk setup in appHelper.ts
	},
	shutdown: () => {
		// Shutdown now handled via Zendesk
	},
	// eslint-disable-next-line no-unused-vars
	trackEvent: event => {
		// Event tracking now handled via Analytics service
	},
	// eslint-disable-next-line no-unused-vars
	on: (event, fn) => {
		// Event listening now handled via Zendesk API
		return () => {};
	}
};

export default InAppChat;
